export default "__VITE_ASSET__D0Tl3fL3__"